import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class Grid extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { classList, gridStyle } = this.props;

    return (
      <section className={`display-grid ${classList}`} style={gridStyle}>
        {this.props.children}
      </section>
    );
  }
}

Grid.propTypes = {
  children: PropTypes.array.isRequired,
  gridStyle: PropTypes.object,
  classList: PropTypes.string,
};

Grid.defaultProps = {
  gridStyle: {},
  classList: '',
};

export default Grid;
